import { HTMLAttributes, forwardRef } from "react";

import { twMerge } from "tailwind-merge";

const InlineCode = forwardRef<HTMLSpanElement, HTMLAttributes<HTMLSpanElement>>(
  ({ className, children, ...rest }, ref) => {
    return (
      <code
        className={twMerge(
          "inline-block whitespace-break-spaces rounded-md bg-[#afb8c133] px-1.5 py-0.5 text-sm",
          className,
        )}
        ref={ref}
        {...rest}
      >
        {children}
      </code>
    );
  },
);

InlineCode.displayName = "InlineCode";

export default InlineCode;
